import { render, staticRenderFns } from "./statusreport_adv.vue?vue&type=template&id=55107745"
import script from "./statusreport_adv.vue?vue&type=script&lang=js"
export * from "./statusreport_adv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports